/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 * 
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$( document ).ready(function() {
  $('.all_testimonials').slick({
    dots: true,
    arrows: false,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,

  });

  $('.all_images').slick({
    dots: true,
    arrows: false,
    //   autoplay: true,
    //   autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,

  });


  $('.custom_css').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,

    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });

  $(".custom_id_clickk").click(function(e){
    e.preventDefault();
    $(".custom_id_option button").trigger("click");
  });


  if($(window).width() <=768 ){
    $('.main_image_with_text_custom').slick({
      arrows: true,
      prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style=''><i class='fas fa-chevron-left'></i></button>",
      nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button' style=''><i class='fas fa-chevron-right'></i></button>",
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,

    });
  }
  $('.ProductList--carouselnew').slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
//   $('.ProductList--carouselx').slick({
//     dots: true,
//     arrows: true,
//     infinite: false,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 769,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
  

  $('.homepage_testimonial').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    //   autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    loop:true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });
  $('.abc').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    //   autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    loop:true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });

  $('.icon_mob_slide').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    //   autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    loop:true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}); 


$('.cust_slide').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.abcd').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    //   autoplaySpeed: 2000,
    infinite: true,
    draggable: false,
    swipe: false,
    touchMove: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    loop:true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });